import type { ListedConnector } from "../../../api/connectorsApi";

/**
 * What a PC's line offers when the server offers a newer connector release than the one that
 * runs there (F159): Update, which that PC's tray installs in one go, or, for a PC without a
 * tray (Linux, `updates/1` absent), the release's own installer or command.
 */
export interface UpdateOffer {
  readonly version: string;
  readonly through: "tray" | "installer";
}

/** `null` when nothing is newer, the PC is not connected, or its version is not known yet. */
export function updateOffer(connector: ListedConnector, offeredVersion: string | null): UpdateOffer | null {
  const running = connector.status.runningVersion;
  if (offeredVersion === null || running === null || !connector.status.online || connector.hostedByServer) return null;
  if (!isOlderRelease(running, offeredVersion)) return null;
  return { version: offeredVersion, through: connector.device.platformOs === "linux" ? "installer" : "tray" };
}

const RELEASE_VERSION = /^(\d+)\.(\d+)\.(\d+)$/;

/** Whether release `running` comes before release `offered` (both major.minor.patch); `false` for anything else. */
export function isOlderRelease(running: string, offered: string): boolean {
  const a = RELEASE_VERSION.exec(running);
  const b = RELEASE_VERSION.exec(offered);
  if (a === null || b === null) return false;
  for (let part = 1; part <= 3; part += 1) {
    const difference = Number(a[part]) - Number(b[part]);
    if (difference !== 0) return difference < 0;
  }
  return false;
}
